<template>
  <div class="boxme">
    <el-card class="box-card" style="width:20%;min-width:300px;height: 90vh;margin:0;margin-right:15px;">
      <div slot="header" class="clearfix">
        <el-button type="primary" plain style="width:100%;margin-bottom:20px;" @click="clearCoach">全部教练</el-button>
        <el-input v-model="listQuery.name" placeholder="请输入教练姓名">
          <el-button slot="append" icon="el-icon-search" @click="SearchData"></el-button>
        </el-input>
      </div>
      <ul class="el-coach">
        <li v-for="(coach,index) in list" :key="index" :class="{'active':coach.id === coach_id}" @click="selectCoach(coach)">
          <el-avatar :size="20" :src="coach.avatar" @error="true">
            <img :src="base_url+'static/image/default_avatar.png'">
          </el-avatar>
          <span style="margin-left:10px;"> {{ coach.name }}</span>
        </li>
      </ul>
      <pagination v-show="total > 10" layout="prev, pager, next" small :pager-count="5" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="loadData" />
    </el-card>

    <el-card v-if="show == 0" class="box-card" style="width:80%;min-width:1000px;height: 90vh;margin:0;">
      <course-all></course-all>
    </el-card>

    <el-card v-else-if="show > 0" class="box-card" style="width:80%;min-width:1000px;height: 90vh;margin:0;">
      <course v-if="show > 0" :coach-id="coach_id"></course>
    </el-card>

  </div>

</template>

<script>
import api from '@/api/coach/coach' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
import CourseAll from './components/course_all'
import Course from './components/course'

export default {
  name: 'Lesson',
  components: { Pagination, CourseAll, Course },
  // 列绑定格式化器
  filters: {
  },
  mixins: [commonList],
  data() {
    return {
      base_url: process.env.VUE_APP_BASE_API,
      api,
      show: 0, // 0刚进入页面显示大日历，1显示单个教练日历，2显示课程计划页面
      // 校验
      rules: {
      },
      listQuery: {
        status: 1,
        page: 1,
        limit: 10, // 页大小
        order: 'asc', // 默认排序方式,
        sort: 'order_no'
      },
      coach_id: ''
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    selectCoach(coach) {
      this.coach_id = coach.id
      this.show = 1
    },
    clearCoach() {
      this.coach_id = ''
      this.show = 0
    }

  }
}
</script>
<style>
.boxme{
  display: flex;
  padding:10px;
}
.el-coach{
  width:100%;
}
.el-coach li{
  height: 56px;
  line-height: 56px;
  font-size: 14px;
  color: #303133;
  padding: 0 20px;
  list-style: none;
  cursor: pointer;
  position: relative;
  transition: border-color .3s, background-color .3s, color .3s;
  box-sizing: border-box;
  white-space: nowrap;
  border-bottom: 1px dotted #e8f4ff !important;
  display:flex;
  align-items: center;
}
.el-coach .active{
  color: #1890ff;
  background:#e8f4ff;
}
.el-coach li:hover{
  background:#e8f4ff;
}
</style>
